import type { MessagingGetChatMessages200PageAllOfThreeContentItemAllOfOnezeroMedia } from './messagingGetChatMessages200PageAllOfThreeContentItemAllOfOnezeroMedia';

export type MessagingGetChatMessages200PageAllOfThreeContentItemAllOfOnezero = {
  /** 미디어 정보 */
  media?: MessagingGetChatMessages200PageAllOfThreeContentItemAllOfOnezeroMedia;
};
